import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/** The parent component of a set of pages used to reload medications into the Knightmeds */
@Component({
  selector: 'app-reload-pages',
  template: `<router-outlet />`,
  styles: [],
  standalone: true,
  imports: [
    RouterOutlet,
  ]
})
export class ReloadPagesComponent { }
